import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
	ItCardComponent,
	ItIconComponent,
	ItButtonDirective,
	ItProgressButtonComponent,
} from 'design-angular-kit';
import type { Dossier } from '../interfaces/dossier';
import type { DossierType } from '../interfaces/dossier-type';

@Component({
	selector: 'app-dossier',
	imports: [
		TranslateModule,
		ItCardComponent,
		ItIconComponent,
		ItButtonDirective,
		ItProgressButtonComponent,
		RouterLink,
		DatePipe,
	],
	templateUrl: './dossier.component.html',
	styleUrl: './dossier.component.scss',
})
export class DossierComponent {
	@Input({ required: true }) dossier!: Dossier;
	@Input({ required: true }) dossierType?: DossierType;
	@Input() progressDelete = false;
	@Input() progressImport = false;
	@Output() importDossier = new EventEmitter<Dossier>();
	@Output() deleteDossier = new EventEmitter<Dossier>();
}
